import { Container } from 'components/gruenland/atoms/container/Container';
import { StoreLocator } from 'components/gruenland/pages/store-locator/StoreLocator';
import { TasticProps } from '../../types';

type Props = unknown;

const StoreLocatorTastic = ({ data: {} }: TasticProps<Props>) => {
  return (
    <Container>
      <StoreLocator />
    </Container>
  );
};
export default StoreLocatorTastic;
